export const CONSTANT_1 = 1
export const CONSTANT_2 = 2

export const roleTypeAddMap = new Map([
  [CONSTANT_1, '厂端'],
])

export const roleTypeMap = new Map([
  [CONSTANT_1, '厂端'],
  [CONSTANT_2, '店端']
])
